module.exports = __webpack_public_path__ + "37c2c6e068695fe78982a47ed4cbf510.svg";